import { Upload } from "@mui/icons-material";

export const upload = (props) => {
  return <Upload {...props} />;
};
